/* eslint-disable react/no-array-index-key */
import React from 'react';
import cx from 'utils/classnames';

interface SliderIndexNavProps {
  currentIndex: number;
  handleGotoSlide: (index: number) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  slides: any[];
}

function SliderIndexNav({
  handleGotoSlide,
  slides,
  currentIndex,
}: SliderIndexNavProps): React.ReactElement {
  const getNavButtonClass = (index: number): string =>
    cx({
      sliderIndexNav__button: true,
      'sliderIndexNav__button--isActive': currentIndex === index,
    });

  return (
    <ol className="sliderIndexNav">
      {slides.map((__, index) => (
        <li
          className="sliderIndexNav__item"
          key={`sliderIndexNavItem__${index}`}
        >
          <button
            className={getNavButtonClass(index)}
            type="button"
            onClick={() => handleGotoSlide(index)}
            disabled={currentIndex === index}
          >
            {index}
          </button>
        </li>
      ))}
    </ol>
  );
}

export default SliderIndexNav;
